import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Map } from '../map';
import ResetPassword from '../Users/Common/ResetPassword';
import LoadHistoryPopup from '../LoadHistory/LoadHistoryPopup';
import { setLoadHistoryParams } from '../../actions/load';

const Content = (props) => {

    useEffect(() => {
        props.actions.setLoadHistoryParams({ farmId: props.match.params.farmId, crewId: null, egId: null });
    }, [])

    return <>
        <Map {...props} />
        <ResetPassword />
        <LoadHistoryPopup />
    </>
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        setLoadHistoryParams
    }, dispatch)
});

export default connect(null, mapDispatchToProps)(Content);